import React from "react";

import 'assets/css/swiper.min.css';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import _ from 'underscore';

import GoogleDrive from '../../common/GoogleDrive';

class CarouselImage extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            image_items: props.image_items,
            active_index: props.initialIndex || 0
        };
        this.goToIndex = this.goToIndex.bind(this);
        this.getImages = this.getImages.bind(this);
    }

    componentDidUpdate(prevProps) {
        let cursign = this.props.image_items ? JSON.stringify(_.uniq(this.props.image_items)) : '';
        let prevsign = prevProps.image_items ? JSON.stringify(_.uniq(prevProps.image_items)) : '';
        if (cursign === prevsign) {
            return;
        }
        this.setState({
            image_items:[],
            active_index: 0
        }, ()=>{
            this.setState ({
                image_items: this.props.image_items,
                active_index: this.props.initialIndex || 0
            })
        })
        
    }

    getImages() {
        let result = {
            images: this.state.image_items,
            selected_index: this.state.active_index,
            hasloading: false
        }
        return result;
    }

    goToIndex(newIndex) {
        if (this.animating) return;
        this.setState({ active_index: newIndex });
    }

    render() {
        const mgClassName = this.props.mgClassName ? this.props.mgClassName : "";
        return (
            <div style={{ minHeight: "200px" }}>
                <Swiper
                    modules={[Navigation, Pagination]}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                >
                    {this.state.image_items.map((img, index) => {
                        return (
                            <SwiperSlide key={'carousel_' + index} style={{ width: "100%", height: "200px" }}>
                                <img src={GoogleDrive.file_url(img)} alt='' style={{ width:"70%", height: "100%", objectFit: "contain" }} className={"rounded mx-auto d-block swiper-lazy " + mgClassName} />
                                <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        );
    }
}

export default CarouselImage;